import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { setCvLink, setNewLanguage } from '../../redux/actions';
import styles from './header.module.scss';

const Header = (props) => {
    const { words, setNewLanguage, navigateToSection, refSeparator, setCvLink } = props;
    const [language, setLanguage] = useState('eng');
    const [isOpen, setIsOpen] = useState(false);
    const [isLanguageOpen, setIsLanguageOpen] = useState(false);
    const languageRef = useRef(null);

    const navItems = [
        { id: 'about', label: words.about },
        { id: 'skills', label: words.skills },
        { id: 'portfolio', label: words.portfolio },
        { id: 'experience', label: words.experience },
        { id: 'contacts', label: words.contacts }
    ];

    const languages = [
        { value: 'arm', label: 'Հայ' },
        { value: 'cat', label: 'Cat' },
        { value: 'eng', label: 'Eng' },
        { value: 'rus', label: 'Рус' },
        { value: 'sp', label: 'Esp' }
    ];

    const cvLinkGenerator = (lang) => {
        return `${process.env.REACT_APP_SERVER_ROOT_PROD}/files/${lang}.pdf`;
    };

    useEffect(() => {
        const language = localStorage.getItem('language');
        const cvLink = cvLinkGenerator(language || 'eng');
        setCvLink(cvLink);
        setLanguage(language || 'eng');
    }, [setCvLink]);

    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : '';

        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (languageRef.current && !languageRef.current.contains(event.target)) {
                setIsLanguageOpen(false);
            }
        };

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                setIsLanguageOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);

    const changeLanguageHandler = (lang) => {
        setLanguage(lang);
        setIsLanguageOpen(false);
        const cvLink = cvLinkGenerator(lang);
        setCvLink(cvLink);
        localStorage.setItem('language', lang);
        setNewLanguage(lang);
    };

    const linkClickhendler = (sectionId) => {
        setIsOpen(false);
        if (refSeparator.current) {
            refSeparator.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
        navigateToSection(sectionId);
    };

    return(
        <header className={styles.container}>
            <div className={styles.brand}>
                <div className={styles.brandMark}>AG</div>
                <div>
                    <div className={styles.brandName}>{words.name}</div>
                    <div className={styles.brandRole}>{words.profession}</div>
                </div>
            </div>
            <div className={styles.rightPart}>
                <nav className={styles.itemsContainer}>
                    {navItems.map((item) => (
                        <button key={item.id} type='button' className={styles.item} onClick={() => linkClickhendler(item.id)}>
                            {item.label}
                        </button>
                    ))}
                </nav>
                <div className={styles.controls}>
                    <div className={styles.langContainer} ref={languageRef}>
                        <button
                            type='button'
                            className={`${styles.languageButton} ${isLanguageOpen ? styles.languageButtonOpen : ''}`}
                            onClick={() => setIsLanguageOpen((prev) => !prev)}
                            aria-haspopup='listbox'
                            aria-expanded={isLanguageOpen}
                            aria-label='Select language'
                        >
                            <span className={styles.languageCaption}>Lang</span>
                            <span className={styles.languageValue}>{languages.find((item) => item.value === language)?.label || 'Eng'}</span>
                        </button>
                        <div className={`${styles.languageMenu} ${isLanguageOpen ? styles.languageMenuOpen : ''}`} role='listbox' aria-label='Language options'>
                            {languages.map((item) => (
                                <button
                                    key={item.value}
                                    type='button'
                                    className={`${styles.languageOption} ${language === item.value ? styles.languageOptionActive : ''}`}
                                    onClick={() => changeLanguageHandler(item.value)}
                                    role='option'
                                    aria-selected={language === item.value}
                                >
                                    <span className={styles.languageOptionLabel}>{item.label}</span>
                                    <span className={styles.languageOptionCode}>{item.value.toUpperCase()}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                    <button
                        type="button"
                        className={`${styles.burgerMenu} ${isOpen ? styles.burgerActive : ''}`}
                        onClick={() => setIsOpen(!isOpen)}
                        aria-label="Toggle navigation"
                        aria-expanded={isOpen}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>
            <div className={`${styles.menuContainer} ${isOpen ? styles.menuOpen : ''}`}>
                <button type="button" onClick={() => setIsOpen(false)} className={styles.sideBar} aria-label="Close navigation"></button>
                <div className={styles.menu}>
                    <div className={styles.menuHeader}>Navigate</div>
                    {navItems.map((item) => (
                        <button key={item.id} type='button' className={styles.menuItem} onClick={() => linkClickhendler(item.id)}>
                            {item.label}
                        </button>
                    ))}
                </div>
            </div>
        </header>
    );
};

const mapStateToProps = (state) => {
    return{
        words: state.main.words
    };
};



export default connect(mapStateToProps, {setNewLanguage, setCvLink})(Header)